import { ImgHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

interface SmartImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  priority?: boolean;
  aspect?: string; // e.g. "16/9"
}

export function SmartImage({ src, alt, priority, aspect, className, ...rest }: SmartImageProps) {
  return (
    <img
      src={src}
      alt={alt}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      // @ts-expect-error: fetchpriority is a valid html attr
      fetchpriority={priority ? "high" : "auto"}
      className={cn("bg-muted/40", className)}
      style={aspect ? { aspectRatio: aspect } : undefined}
      {...rest}
    />
  );
}
